import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/bas/app_c64d46a8-83e7-491b-a9b5-0969d13be2c2/apps/web/components/PageWrapperAppDir.tsx");
;
import(/* webpackMode: "eager" */ "/home/bas/app_c64d46a8-83e7-491b-a9b5-0969d13be2c2/node_modules/next/dist/client/script.js");
